(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/init.js');

(function(_, svs) {
  'use strict';

  svs.tt.app = new Marionette.Application({
    region: '.tt-main',

    onStart: function() {
      svs.tt.app.radio = Backbone.Radio.channel('filtering');

      svs.tt.filter = new svs.tt.models.TTFilter();
      svs.tt.draws = new svs.tt.models.Draws();

      svs.tt.logger = new svs.core.log.Logger('module:tt');
      svs.tt.router = new svs.tt.Router();
      Backbone.history.start({
        pushState: true,
        root: svs.core.data.baseUrl,
        hashChange: false
      });
    }
  });

  svs.tt.app.start();
})(_, svs);


 })(window);